import { Card, PageHeader } from "../components/ui";

// Routes whose full implementation lands in a later phase.

export function Settings() {
  return (
    <div className="page">
      <PageHeader title="Settings" />
      <Card><p className="dim">Push notifications + preferences arrive in Phase 8.</p></Card>
    </div>
  );
}
